import { bbox } from '@turf/turf';
import type { AllGeoJSON } from '@turf/helpers';
import type { GeoJSON } from 'geojson';
import Extent from '@arcgis/core/geometry/Extent';
import { WGS84_SPATIAL_REFERENCE } from './spatialReference';

/**
 * Use ArcGIS's built-in fit-to-geometry behavior. When you pass an Extent
 * (centroid) to mapView.goTo() without specifying a zoom level, ArcGIS
 * automatically calculates the zoom that fits the entire Extent in the
 * viewport.
 */
export function getExtentFromGeoJson(geojson: GeoJSON): Extent | null {
  try {
    const [minLng, minLat, maxLng, maxLat] = bbox(geojson as AllGeoJSON);
    const extent = new Extent({
      xmin: minLng,
      ymin: minLat,
      xmax: maxLng,
      ymax: maxLat,
      spatialReference: WGS84_SPATIAL_REFERENCE,
    });

    // Expand by 20% for padding so geometry isn't flush to edges
    return extent.expand(1.2);
  } catch {
    return null;
  }
}
